import { useContext } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { RoutePaths } from "./MarketplacesAppRouter";
import { AppControllerContext } from "./AppControllerContext";
export function MarketplaceSelectorCardComponent(props) {
    const appController = useContext(AppControllerContext);
    if (appController) {
        const navigator = useNavigate();
        function selectMarketplace() {
            navigator(RoutePaths.buildMarketplaceRoute(props.marketplace.Id));
        }
        return (<button id="marketplace-selector-test-id" style="background: var(--emsurge-golden-bright-color); padding: 2rem; border-radius: 3rem; width: 30vw; font-size: 3rem;" onclick={selectMarketplace}>
                {props.marketplace.Name}
            </button>);
    }
    else {
        throw "appController from context is undefined!";
    }
}
